import React from 'react';
import { HiSparkles } from 'react-icons/hi';
import { testIds } from 'src/app/constants';
import LatexHTMLRenderer from 'src/app/components/LatexHTMLRenderer/LatexHTMLRenderer';
import styles from './Nudge.module.scss';
import multipleInputStyles from '../TutorChatBubble/MultipleInput/MultipleInput.module.scss';
import { t } from 'i18next';
import { useOffscreenLatexText } from 'src/app/hooks/useOffscreenLatexText';

type NudgePropType = {
  nudge: string | null;
};

function Nudge(props: NudgePropType) {
  const { nudge } = props;
  const plainExplanationContent = useOffscreenLatexText(nudge ?? ''); 

  if (!nudge) {
    return null;
  }

  return (
    <>
      {plainExplanationContent && <span className={'sr-only'}>{t(`INCORRECT`)} {t(`ANSWER`)} {plainExplanationContent}</span>}
      <div data-test-id={testIds.nudge_section} className={styles.nudgeSection} aria-hidden={true}>
        <div className={styles.header}>
          <HiSparkles size={18} focusable={false} aria-hidden={true} />
          <span>{t('AI_SUGGESTION')}</span>
        </div>
        <div className={`${styles.nudge} ${multipleInputStyles.customizedScroll} overflow-x-auto overflow-y-hidden`}>
          <LatexHTMLRenderer content={nudge} size='small' />
        </div>
      </div>
    </>
  );
}

export default Nudge;
